export default () => {
  const navigationEntries = performance.getEntriesByType(
    "navigation",
  ) as (PerformanceEntry & { type: string })[];

  return (
    navigationEntries.length > 0 && navigationEntries[0]?.type === "reload"
  );
};
